import { useEffect } from 'react'

import moment from 'moment'

import SalesText from '../../components/_atoms/SalesText/SalesText'
import { fontSizes, fontWeights } from '../../constants/salesStyles'
import getAccountPaymentInfo from '../../modules/redux/user/getAccountPaymentInfo'
import { useDispatch } from '../../modules/store/customDispatch'
import { useSelector } from '../../modules/store/customSelector'

import styles from './styles.module.scss'

const Billing = () => {
    const dispatch = useDispatch()
    const paymentInfo = useSelector(state => state.userData.paymentInfo)
    const paymentInfoLoaded = useSelector(state => state.userData.paymentInfoLoaded)

    useEffect(() => {
        dispatch(getAccountPaymentInfo())
    }, [])

    const tariffs = [
        { name: 'Лёгкая подписка до 1000 товаров', oldPrice: '2000', newPrice: '3000', perItem: '3.00' },
        { name: 'Лёгкая подписка до 2000 товаров', oldPrice: '2000', newPrice: '3200', perItem: '1.60' },
        { name: 'Лёгкая подписка до 3000 товаров', oldPrice: '2000', newPrice: '3600', perItem: '1.20' },
        { name: 'Стандартная подписка от 3000 до 5000 товаров', oldPrice: '3500', newPrice: '4600', perItem: '0.92' },
        { name: 'Стандартная подписка от 5000 до 7000 товаров', oldPrice: '3500', newPrice: '5500', perItem: '0.79' },
        { name: 'Расширенная подписка от 7000 до 15000 товаров', oldPrice: '5500', newPrice: '9500', perItem: '0.63' },
        { name: 'Профессиональная подписка от 15\u00a0000 до 50\u00a0000 товаров', oldPrice: '9000', newPrice: '14500', perItem: '0.29' },
    ]

    const additionalServices = [
        { name: 'Ежедневный импорт с кастомизацией', oldPrice: '5000', newPrice: '6000', badge: null },
        { name: 'Ежедневный экспорт на Ozon', oldPrice: '5000', newPrice: '5000', badge: null },
        { name: 'Доп. пользователь (лёгкая / стандартная подписка)', oldPrice: '700', newPrice: '700', badge: null },
        { name: 'Ежедневный импорт до 15k запчастей (без подписки)', oldPrice: '5000', newPrice: '5000', badge: null },
        { name: 'Разовый импорт / перенос базы', oldPrice: '4000', newPrice: '5000', badge: 'при оплате подписки от 3 мес — бесплатно' },
    ]

    const discounts = [
        { period: 'При оплате за 3 мес', discount: '10%' },
        { period: 'При оплате за 6 мес', discount: '12%' },
        { period: 'При оплате за 12 мес', discount: '15%' },
    ]

    return (
        <div className={styles.wrap}>
            <SalesText
                text={'Тарифный план'}
                fontWeight={fontWeights.bold}
                fontSize={fontSizes.xxl}
                letterSpacing={-0.02}
            />

            {!paymentInfo && paymentInfoLoaded && (
                <div className={styles.noTariffMessage}>
                    <p>Тариф не выбран. Пожалуйста, выберите подходящий тариф ниже
                    <br />
                    и свяжитесь с менеджером в Telegram{' '}
                    {/* Временно скрыто: поддержка в МАКС
                        <a href="https://max.ru/u/f9LHodD0cOIAVt7Zg_ukFhe6Qw_5sgNWro0T4-_WyxIKxbVugh-hydSRlno" target="_blank" rel="noopener noreferrer">
                            МАКС +79365150373
                        </a> или Telegram{' '}
                    */}
                    <a href="https://t.me/partsautoexpert_bot" target="_blank" rel="noopener noreferrer">
                        @partsautoexpert_bot
                    </a>
                    </p>
                </div>
            )}

            {paymentInfo && paymentInfoLoaded && (
                <div className={styles.currentTariff}>
                    <div className={styles.infoRow}>
                        <span className={styles.label}>Текущий тариф:</span>
                        <span className={styles.value}>{paymentInfo.paymentRemark}</span>
                    </div>
                    <div className={styles.infoRow}>
                        <span className={styles.label}>Сумма в мес:</span>
                        <span className={styles.value}>{paymentInfo.paymentAmount} руб/мес</span>
                    </div>
                    <div className={styles.infoRow}>
                        <span className={styles.label}>Оплачено до:</span>
                        <span className={styles.value}>{moment(paymentInfo.paymentDue).format('DD.MM.YYYY')}</span>
                    </div>

                    <div className={styles.linksSection}>
                        <div className={styles.linkRow}>
                            <span>Ссылка на оплату 1 мес:</span>
                            <a href={paymentInfo.paymentLink} target="_blank" rel="noopener noreferrer">
                                ссылка
                            </a>
                        </div>
                        {(paymentInfo.paymentLink.includes('light-1') || paymentInfo.paymentLink.includes('standard-1')) && (
                            <div className={styles.linkRow}>
                                <span>Ссылка на оплату 3 мес:</span>
                                <a
                                    href={paymentInfo.paymentLink.replace('light-1', 'light-3').replace('standard-1', 'standard-3')}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    ссылка со скидкой
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            )}

            <h2 className={styles.sectionTitle}>Тарифная сетка с Ноября 2025</h2>

            <section className={styles.section}>
                <h3 className={styles.subtitle}>Подписка</h3>
                <div className={styles.tableWrap}>
                    <table className={styles.table}>
                        <thead>
                            <tr>
                                <th>Тариф</th>
                                <th>Старая цена / мес</th>
                                <th>Новая цена / мес</th>
                                <th>Цена за 1 товар</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tariffs.map((tariff, index) => (
                                <tr key={index}>
                                    <td>{tariff.name}</td>
                                    <td>
                                        <span className={styles.priceOld}>{tariff.oldPrice}</span>
                                    </td>
                                    <td className={styles.priceNew}>{tariff.newPrice}</td>
                                    <td>{tariff.perItem}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <p className={styles.note}>Цена за 1 товар рассчитана на верхней границе диапазона тарифа.</p>
            </section>

            <section className={styles.section}>
                <h3 className={styles.subtitle}>Дополнительные услуги</h3>
                <div className={styles.tableWrap}>
                    <table className={styles.table}>
                        <thead>
                            <tr>
                                <th>Услуга</th>
                                <th>Старая цена / мес</th>
                                <th>Новая цена / мес</th>
                            </tr>
                        </thead>
                        <tbody>
                            {additionalServices.map((service, index) => (
                                <tr key={index}>
                                    <td>
                                        {service.name}
                                        {service.badge && <span className={styles.badge}>{service.badge}</span>}
                                    </td>
                                    <td>
                                        <span className={styles.priceOld}>{service.oldPrice}</span>
                                    </td>
                                    <td className={styles.priceNew}>{service.newPrice}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </section>

            <section className={styles.section}>
                <h3 className={styles.subtitle}>Скидки при оплате вперёд</h3>
                <div className={styles.tableWrap}>
                    <table className={styles.table}>
                        <thead>
                            <tr>
                                <th>Период оплаты</th>
                                <th>Скидка</th>
                            </tr>
                        </thead>
                        <tbody>
                            {discounts.map((discount, index) => (
                                <tr key={index}>
                                    <td>{discount.period}</td>
                                    <td className={styles.priceNew}>{discount.discount}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
    )
}

export default Billing
